import HistoryItem from './history-item';

export default HistoryItem;